import { render, staticRenderFns } from "./ModosDePagamento.vue?vue&type=template&id=163edb95&"
import script from "./ModosDePagamento.vue?vue&type=script&lang=js&"
export * from "./ModosDePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports